/** Avisos efimeros (toast) de la interfaz. */
import { defineStore } from "pinia";
import { ref } from "vue";

const TOAST_MS = 3200;

export const useUiStore = defineStore("ui", () => {
  const toast = ref<string | null>(null);
  let timer: ReturnType<typeof setTimeout> | undefined;

  function showToast(message: string, ms = TOAST_MS): void {
    toast.value = message;
    clearTimeout(timer);
    timer = setTimeout(() => (toast.value = null), ms);
  }

  function dismissToast(): void {
    clearTimeout(timer);
    toast.value = null;
  }

  return { toast, showToast, dismissToast };
});
